import styled from 'styled-components';
import { width, isPortrait } from '../../utils/size';
import { styledScrollbar } from '../../components/Shared/mixins';

export const mobileResolution = () => {
    if (width() < 300) return 0;
    return width() - 300;
};

export const desktopResolution = isLarge => {
    var windowInnerWidth = 0;
    if (width() < 480) return 0;
    if (width() > 630) {
        windowInnerWidth = 630;
    }
    if (width() === 630) return width() - 368;
    if (windowInnerWidth > 0) {
        return windowInnerWidth - 358;
    } else {
        return width() - isLarge ? 171 : 262;
    }
};

export const OverlayBackground = styled.div`
    position: absolute;
    display: ${props => (props.isVisible ? 'flex' : 'none')};
    overflow: hidden;
    width: 100%;
    height: 100%;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    background-color: ${props =>
        props.isVisible ? 'rgba(0, 0, 0, 0.5)' : 'rgba(0, 0, 0, 0)'};
    z-index: 3;

    &.transition-enter {
        display: flex;
        background-color: rgba(0, 0, 0, 0);
    }

    &.transition-enter.transition-enter-active {
        display: flex;
        background-color: rgba(0, 0, 0, 0.5);
        transition: background-color 0.3s linear;
    }

    &.transition-exit {
        display: flex;
        background-color: rgba(0, 0, 0, 0.5);
    }

    &.transition-exit.transition-exit-active {
        display: flex;
        background-color: rgba(0, 0, 0, 0);
        transition: background-color 0.3s linear;
    }
`;

export const AboutUs = styled.div`
    transform: ${({ isVisible, transitionType }) =>
        isVisible
            ? `${
                  transitionType === 'left-to-right'
                      ? 'translate(0, 0)'
                      : 'translate(262px, 0)'
              }`
            : `${
                  transitionType === 'left-to-right'
                      ? 'translate(0, 0)'
                      : 'translate(620px, 0)'
              }`};

    position: relative;
    background-color: rgba(256, 256, 256, 1);
    opacity: 2;
    padding: 1.125em 1em 1.125em 1em;
    flex-direction: column;
    box-shadow: 0 12px 24px 0 rgba(0, 0, 0, 0.5);
    border: solid 1px #f3f1f1;
    display: inline;

    &.transition-enter {
        transform: ${({ transitionType }) =>
            transitionType === 'left-to-right'
                ? 'translate(-358px, 0)'
                : 'translate(620px, 0)'};
    }

    &.transition-enter.transition-enter-active {
        transition: transform 0.3s ease-out;
        transform: translate(0, 0);

        transform: ${({ transitionType }) =>
            transitionType === 'left-to-right'
                ? 'translate(0, 0)'
                : `translate(${desktopResolution()}px, 0)`};

        @media (max-width: 30em) {
            transform: ${({ transitionType }) =>
                transitionType === 'left-to-right'
                    ? 'translate(0, 0)'
                    : `translate(${mobileResolution()}px, 0)`};
        }
    }

    &.transition-exit {
        transform: ${({ transitionType }) =>
            transitionType === 'left-to-right'
                ? 'translate(0, 0)'
                : `translate(${desktopResolution()}px, 0)`};

        @media (max-width: 30em) {
            transform: ${({ transitionType }) =>
                transitionType === 'left-to-right'
                    ? 'translate(0, 0)'
                    : `translate(${mobileResolution()}px, 0)`};
        }
    }

    &.transition-exit.transition-exit-active {
        transition: transform 0.3s ease-in;
        transform: ${({ transitionType }) =>
            transitionType === 'left-to-right'
                ? 'translate(-358px, 0)'
                : 'translate(620px, 0)'};
    }

    @media (min-width: 30em) {
        width: 358px;
        transform: ${({ transitionType }) =>
            transitionType === 'left-to-right'
                ? 'translate(0, 0)'
                : `translate(${desktopResolution()}px, 0)`};
    }

    @media (max-width: 30em) {
        max-width: 310px;
        width: 100%;
        transform: ${({ transitionType }) =>
            transitionType === 'left-to-right'
                ? 'translate(0, 0)'
                : `translate(${mobileResolution()}px, 0)`};
    }
`;

export const AboutUsHeader = styled.div`
    display: flex;
    align-items: center;
`;

export const AboutUsBody = styled.div`
    display: flex;
    flex-direction: column;
    flex: 1;
    overflow-y: auto;
    word-wrap: break-word;

    > div {
        p {
            &:last-child {
                display: ${props => props.isEmailSubmitted && 'none'};
            }
        }
    }
`;

export const CloseButton = styled.div`
    z-index: 1;
    width: 14px;
    height: 26px;
    transform: rotate(45deg);
    font-family: Averta;
    font-size: 24px;
    line-height: 1.08;
    text-align: left;
    color: #5d656c;
    margin-top: -0.625em;
    cursor: pointer;
`;

export const AboutUsTitle = styled.div`
    font-size: 16px;
    line-height: 1.63;
    text-align: left;
    margin-bottom: 0.5em;
`;

export const AboutUsText = styled.div`
    font-family: Lato;
    font-size: 14px;
    line-height: 1.43;
    text-align: left;
    ${({ theme }) => styledScrollbar(theme.colors.primary)};
    color: ${props => (props.isMobileResolution ? '#5d656c' : '#333333')};
    ${props => props.allowScroll && !isPortrait() && 'overflow-y: auto; height: 240px;'};
    ${props => props.allowScroll && isPortrait() && 'overflow-y: auto; height: 380px;'};

    @media (min-width: 30em) {
        ${props => props.isRockTheVote && 'overflow-y: scroll; height: 240px;'};
    }
`;

export const Body = styled.div`
    ${({ isPartnerOrPublisherOverlay }) =>
        !isPartnerOrPublisherOverlay &&
        `
            margin: 0 15px 0 0;
            position: absolute;
            top: 50%;
            transform: translateY(-50%);
        `};
`;

export const RepOverlayContainer = styled(AboutUs)`
    padding: 22px;
    height: 100%;
    &.transition-enter {
        transform: ${({ transitionType }) =>
            transitionType === 'left-to-right'
                ? 'translate(-450px, 0)'
                : 'translate(620px, 0)'};
    }

    &.transition-enter.transition-enter-active {
        transition: transform 0.3s ease-out;
        transform: translate(0, 0);

        transform: ${({ transitionType }) =>
            transitionType === 'left-to-right'
                ? 'translate(0, 0)'
                : `translate(${desktopResolution(true)}px, 0)`};

        @media (max-width: 30em) {
            transform: ${({ transitionType }) =>
                transitionType === 'left-to-right'
                    ? 'translate(0, 0)'
                    : `translate(${mobileResolution()}px, 0)`};
        }
    }

    &.transition-exit {
        transform: ${({ transitionType }) =>
            transitionType === 'left-to-right'
                ? 'translate(0, 0)'
                : `translate(${desktopResolution(true)}px, 0)`};

        @media (max-width: 30em) {
            transform: ${({ transitionType }) =>
                transitionType === 'left-to-right'
                    ? 'translate(0, 0)'
                    : `translate(${mobileResolution()}px, 0)`};
        }
    }

    &.transition-exit.transition-exit-active {
        transition: transform 0.3s ease-in;
        transform: ${({ transitionType }) =>
            transitionType === 'left-to-right'
                ? 'translate(-450px, 0)'
                : 'translate(620px, 0)'};
    }

    @media (min-width: 30em) {
        width: 450px;
        transform: ${({ transitionType }) =>
            transitionType === 'left-to-right'
                ? 'translate(0, 0)'
                : `translate(${desktopResolution(true)}px, 0)`};
    }

    @media (max-width: 30em) {
        max-width: 310px;
        width: 100%;
        transform: ${({ transitionType }) =>
            transitionType === 'left-to-right'
                ? 'translate(0, 0)'
                : `translate(${mobileResolution()}px, 0)`};
    }
`;

export const RepOverlayHeader = styled.div`
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    align-items: flex-start;

    h3 {
        font-family: Averta;
        font-size: 28px;
        font-weight: 300;
        line-height: 1.21;
        color: #000000;
        flex: 1;
        margin: 0;
    }
`;

export const RepOverlayBody = styled(Body)`
    overflow-y: auto;
    overflow-x: none;
    padding-right: 5px;
    max-height: ${() => (isPortrait() ? 70 : 55)}%;
    ${props => !props.nextAction && `max-height: unset;`};
    margin: 0.5em 0;
    ${({ theme }) => styledScrollbar(theme.colors.primary)};
`;

export const RepSection = styled.div`
    font-family: Averta;
    margin-top: 1em;

    span {
        color: #008eff;
        text-decoration: none;
        cursor: pointer;
    }

    &:first-child {
        margin-top: 0;
    }
    h4 {
        margin: 0.5em 0 0.25em;
        font-size: 8px;
        font-weight: bold;
        line-height: 1.5;
        letter-spacing: 1px;
        color: #979191;
    }

    p {
        margin: 0;
        font-size: 12px;
        line-height: 1.33;
        color: #000000;
    }

    a {
        text-decoration: none;
        color: #008eff;
    }
`;

export const RepAction = styled.button`
    cursor: pointer;
    background-color: white;
    height: 56px;
    border-radius: 4px;
    width: calc(100% - 44px);
    position: absolute;
    bottom: 22px;
    border: solid 1px #f1f1ee;

    &:active,
    &:focus {
        outline: none;
    }

    &:hover {
        background-color: ${({ theme }) => theme.colors.primary};
        border: ${({ theme }) => `solid 1px ${theme.colors.primary}`};
        color: #fff;
        span {
            color: #fff;
        }
    }

    span {
        font-family: Averta;
        font-size: 18px;
        font-weight: 600;
        font-style: normal;
        font-stretch: normal;
        line-height: 1.22;
        letter-spacing: 1.5px;
        text-align: center;
        color: #000000;
    }
`;
